import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {
  searchGroupObjects as searchGroupObjectsAPI,
  searchGanttObjects as searchGanttObjectsAPI,
} from '../../../services/groups'
import {ActionTypes} from './reducer'

export function resetResources(dispatch) {
  dispatch({type: ActionTypes.RESET})
}

export async function removeEventViaID(dispatch, entity_object_id, id) {
  try {
    dispatch({
      type: ActionTypes.REMOVE_EVENT_VIA_ID,
      payload: {entity_object_id: entity_object_id, id: id},
    })
  } catch (e) {
    console.log(`Remove Item Failed`)
    return Promise.reject(e)
  }
}

export async function searchGroupObjects(
  dispatch,
  group_id,
  view_data,
  params = {},
  events_only = false
) {
  try {
    dispatch({type: PENDING})
    let response = await searchGroupObjectsAPI(group_id, params)
    if (view_data && response) {
      response['view_data'] = view_data
    }
    dispatch({type: SUCCESS, payload: {...response, events_only}})
    return response
  } catch (e) {
    console.log(`Search Group Objects Failed`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}

export async function searchGanttObjects(
  dispatch,
  group_id,
  view_data,
  params = {},
  events_only = false
) {
  try {
    dispatch({type: PENDING})
    let response = await searchGanttObjectsAPI(group_id, params)
    if (view_data && response) {
      response['view_data'] = view_data
    }
    dispatch({type: SUCCESS, payload: {...response, events_only}})
    return response
  } catch (e) {
    console.log(`Search Group Objects Failed`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
